import en from './en.json';
import es from './es.json';
import pt from './pt.json';

export const languages = { es, en, pt };
